import { useMemo } from 'react';
import { connect } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';

const RouteDetailsGridPanel = ({ allRouteDetailsData, filters, customers }) => {

    const filteredData = useMemo(() => {
        if (!allRouteDetailsData || allRouteDetailsData.length === 0) return [];
        const rows = filters.route && filters.route.id
            ? allRouteDetailsData.filter(row => row.route_system_id === filters.route.id)
            : allRouteDetailsData;

        return rows.map(row => ({
            ...row,
            filter_date: row.scan_date || '',
            filter_customer: (() => {
                const c = (customers || []).find(c => c.customer_id === filters.customer);
                return c ? c.customer_name : (filters.customer || '');
            })(),
            filter_dc: row.dc_name || filters.dc || ''
        }));
    }, [allRouteDetailsData, filters, customers]);

    const columns = [
        { field: 'filter_date', headerName: 'Date', width: 110, valueFormatter: (params) => {
            if (!params.value) return '';
            const [y, m, d] = params.value.split('-');
            return `${m}-${d}-${y}`;
        } },
        { field: 'filter_customer', headerName: 'Customer', width: 160 },
        { field: 'filter_dc', headerName: 'DC', width: 160 },
        { field: 'local_route', headerName: 'Route', width: 100 },
        { field: 'stop_number', headerName: 'Stop Number', width: 130, type: 'number' },
        { field: 'store_name', headerName: 'Stop Name', width: 180 },
        { field: 'pallet_number', headerName: 'Pallet ID', width: 120 },
        { field: 'dock_door', headerName: 'Planned Door', width: 130 },
        { field: 'door_detected', headerName: 'Door Detected', width: 130 },
        { field: 'loaded_stop_number', headerName: 'Order Through Door', width: 160, type: 'number' },
        { field: 'operation_time_local', headerName: 'Last Read Time', width: 180 },
        { field: 'status', headerName: 'Door Status', width: 120 },
        { field: 'sequence_status', headerName: 'Sequence Status', width: 140 }
    ];

    return (
        <div style={{ width: '100%' }}>
            <DataGrid
                autoHeight
                rows={filteredData}
                columns={columns}
                hideFooter
                sortModel={[{ field: 'stop_number', sort: 'desc' }]}
                disableSelectionOnClick
                getRowId={(row) => row.id}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    allRouteDetailsData: state.loadValidationDashboard.routeDetailsData,
    filters: state.loadValidationDashboard.filters,
    customers: state.edgePCs.customers || []
});

export default connect(mapStateToProps)(RouteDetailsGridPanel);
